let PermissionManager = class {
  static CONTAINER_QUERY_SELECTOR = '#sflowPermissionManager';
  data = window.sflow.data;
  el = this.createElementReferences();

  setPermissionsOfRole (role = null) {
    if (role === null) {
      return;
    }

    // Permission keys the current editor is allowed to grant. When present, a
    // checkbox outside this set stays disabled regardless of role selection so a
    // constrained editor can never toggle a permission beyond their authority.
    const grantable = this.data.grantablePermissions;
    const isGrantable = (value) => !grantable || grantable.includes(value);

    this.el.permissionCheckboxes.forEach((checkbox) => {
      if (role.permissions.find((permission) => permission.permission_key === checkbox.value)) {
        checkbox.checked = true;
        checkbox.disabled = true;
      } else {
        checkbox.disabled = !isGrantable(checkbox.value);
        if (this.data.accountBeingEdited) {
          checkbox.checked = this.data.accountBeingEdited.account_permissions.find((permission) => permission.permission_key === checkbox.value);
        }
      }
    });
  }

  createElementReferences () {
    const container = document.querySelector(PermissionManager.CONTAINER_QUERY_SELECTOR);
    return {
      container: container,
      permissionCheckboxes: container.querySelectorAll('article label input'),
    };
  }

  toggleVisibility () {
    if (this.el.container.hidden) {
      this.el.container.hidden = false;
      sflow.roleManager.el.permissionButtonDirection.innerHTML = RoleManager.CHAR_UP_ARROW;
    } else {
      this.el.container.hidden = true;
      sflow.roleManager.el.permissionButtonDirection.innerHTML = RoleManager.CHAR_DOWN_ARROW;
    }
  }
};

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector(PermissionManager.CONTAINER_QUERY_SELECTOR) !== null) {
    window.sflow.permissionManager = new PermissionManager();
  }
});
